var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup138(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(-1013 -381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    transform: "translate(1013 381)",
    fill: "#fff",
    stroke: "#bbe1ff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_graph",
    "data-name": "vuesax/bold/graph",
    transform: "translate(723 202)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graph"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.26,4.949A6.982,6.982,0,0,0,4.64.329c-1.65-.48-2.79-.44-3.58.15A3.484,3.484,0,0,0,0,3.379v2.49c0,2.46,1.12,3.71,3.32,3.71H6.19a3.5,3.5,0,0,0,2.9-1.06C9.7,7.739,9.75,6.6,9.26,4.949Z",
    transform: "translate(312.41 190.001)",
    fill: "#2ba0fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M16.907,8.611a1.368,1.368,0,0,0-1.03-.47H12.3a3.192,3.192,0,0,1-3.19-3.19V1.371a1.368,1.368,0,0,0-.47-1.03,1.355,1.355,0,0,0-1.07-.33,8.733,8.733,0,0,0-5.92,3.53,8.633,8.633,0,0,0,5.36,13.55,8.387,8.387,0,0,0,1.65.16,8.5,8.5,0,0,0,5.05-1.65,8.733,8.733,0,0,0,3.53-5.92A1.344,1.344,0,0,0,16.907,8.611Z",
    transform: "translate(302.003 192.749)",
    fill: "#2ba0fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(324 212) rotate(180)",
    fill: "none",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup138);
export default __webpack_public_path__ + "static/media/Group 138.724fe04db754e4e87bcb36d1a49f504d.svg";
export { ForwardRef as ReactComponent };